module.exports = __webpack_public_path__ + "static/media/numero2 copia.eb8fd5c2.png";